import { SimpleForm } from 'react-admin';
import { styled } from '@mui/material/styles';

export const SimpleFormStyled = styled(SimpleForm)({
  paddingTop: '20px',
});
